import user from '@/api/api_user';
import goodstender from '@/api/api_goodstender';
import resource from '@/api/api_resources';
import domain from '@/api/api_domain';
import specialbidding from '@/api/api_specialbidding';
import contract from '@/api/api_contract';
import guestUnity from '@/api/api_guestUnity';
import newproduct from '@/api/api_newproduct';
import selectgoods from '@/api/api_selectgoods';

export default {
  user,
  goodstender,
  resource,
  domain,
  specialbidding,
  contract,
  guestUnity,
  selectgoods,
  newproduct
};


// WEBPACK FOOTER //
// ./src/api/index.js